import { API_URL } from "../utils/constants";
import { fetchWithAuth } from "../utils/auth";
import { ITenant } from "./tenant/tenantService";
import { ILease } from "./leaseService";
import { IDocument, DocumentType } from "./documentService";

export interface ITenancyContractDetails {
  tenant: ITenant;
  lease: ILease;
}

export const fetchTenantRegistration = async (
  token: string
): Promise<ILease> => {
  const response: Response = await fetchWithAuth(
    `${API_URL}/tenant-registration/${token}`,
    {
      method: "GET",
    }
  );

  const data = await response.json();
  if (!response.ok) throw new Error(data.message);

  return data;
};

export const finishTenantRegistration = async (
  token: string
): Promise<void> => {
  const response: Response = await fetchWithAuth(
    `${API_URL}/tenant-registration/${token}/finish`,
    {
      method: "POST",
    }
  );

  const data = await response.json();
  if (!response.ok) throw new Error(data.message);
};

export interface IUpdateTenantRegistration {
  birth_date: string;
  nationality: string;
  email: string;
  phone_number: string;
  //has_pets: boolean;
  occupants: any[];
}

export const updateTenantRegistration = async (
  token: string,
  registrationDetails: IUpdateTenantRegistration
): Promise<ILease> => {
  const response: Response = await fetchWithAuth(
    `${API_URL}/tenant-registration/${token}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(registrationDetails),
    }
  );

  const data = await response.json();
  if (!response.ok) throw new Error(data.message);

  return data;
};

export const uploadTenantDocuments = async (
  token: string,
  document_type: DocumentType,
  files: File[],
  valid_until_dates: (string | null)[] = [],
  document_identifiers: (string | null)[] = []
): Promise<IDocument[]> => {
  const formData = new FormData();

  files.forEach((file, index) => {
    formData.append(`file_${index}`, file);
    if (valid_until_dates[index]) {
      formData.append(
        `valid_until_${index}`,
        valid_until_dates[index] as string
      );
    }
    if (document_identifiers[index]) {
      formData.append(
        `document_identifier_${index}`,
        document_identifiers[index] as string
      );
    }
  });

  const response = await fetchWithAuth(
    `${API_URL}/tenant-registration/${token}/tenant-documents/${document_type}`,
    {
      method: "POST",
      body: formData,
    }
  );

  const data = await response.json();
  if (response.status === 201) return data.documents;
  else throw new Error(data.message);
};

export const uploadOccupantDocuments = async (
  token: string,
  occupant_id: number,
  document_type: DocumentType,
  files: File[],
  valid_until_dates: (string | null)[] = [],
  document_identifiers: (string | null)[] = []
): Promise<IDocument[]> => {
  const formData = new FormData();

  files.forEach((file, index) => {
    formData.append(`file_${index}`, file);
    if (valid_until_dates[index]) {
      formData.append(
        `valid_until_${index}`,
        valid_until_dates[index] as string
      );
    }
    if (document_identifiers[index]) {
      formData.append(
        `document_identifier_${index}`,
        document_identifiers[index] as string
      );
    }
  });

  const response = await fetchWithAuth(
    `${API_URL}/tenant-registration/${token}/occupant-documents/${occupant_id}/${document_type}`,
    {
      method: "POST",
      body: formData,
    }
  );

  const data = await response.json();
  if (response.status === 201) return data.documents;
  else throw new Error(data.message);
};
